export enum PathType {
  UNDEFINED = '',
  ANIMAL_HEALTH = 'SA'
}

export const isPathType = (pathType: string | null): pathType is PathType => {
  switch (pathType) {
    case PathType.ANIMAL_HEALTH:
      return true;
    default:
      return false;
  }
};
